import { TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ViewGroupVectorUser } from './view-group.types';

const SHEET_WINDOW = 'department-employee-sheet';

export class ViewGroupEmployeeSheet {
  employee: ViewGroupVectorUser = null;
  private modal: NgbModalRef = null;

  constructor(private modalService: NgbModal) {}

  open(employee: ViewGroupVectorUser, content: TemplateRef<Object>): void {
    this.close();
    this.employee = employee;
    const modal = this.modalService.open(content, {windowClass: SHEET_WINDOW});
    this.modal = modal;
    const release = () => {
      if (this.modal === modal) { this.modal = null; this.employee = null; }
    };
    modal.result.then(release, release);
  }

  close(): void {
    if (this.modal) { this.modal.close(); }
    this.modal = null;
    this.employee = null;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/view-group-employee-sheet.ts